import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getHighResCover(url: string | null) {
  if (!url) return null;
  return url
    .replace("zoom=1", "zoom=2")
    .replace("zoom=5", "zoom=2")
    .replace("http:", "https:");
}

export { calculateWorkingDays } from "@/lib/vacations/working-days";

export function getBaseUrl() {
  if (process.env.NEXT_PUBLIC_APP_URL) {
    const configuredUrl = process.env.NEXT_PUBLIC_APP_URL.trim();
    return /^https?:\/\//i.test(configuredUrl)
      ? configuredUrl
      : `https://${configuredUrl}`;
  }
  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`;
  }
  return "http://localhost:3000";
}

export function formatHours(
  hoursStrOrNum: number | string | null | undefined,
): string {
  if (hoursStrOrNum === null || hoursStrOrNum === undefined) return "0h";
  const hours = Number(hoursStrOrNum);
  if (isNaN(hours) || hours <= 0) return "0h";

  const totalMinutes = Math.round(hours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  if (m === 0) return `${h}h`;
  if (h === 0) return `${m}m`;
  return `${h}h ${m}m`;
}
